!(function () {
  let e = (e) =>
      !(function e(t) {
        if (t.length % 4 != 0 || !/^[A-Za-z0-9+/=]+$/.test(t)) return !1;
        try {
          return (atob(t), !0);
        } catch (r) {
          return !1;
        }
      })(e)
        ? e
        : decodeURIComponent(escape(window.atob(e))),
    t = {
      is_mark: 'F',
      shop_domain: window?.Shopify?.shop || '',
      watermark_text: e('5rC05Y2w5paH5pys'),
      watermark_size: '20px',
      watermark_color: '#333333'
    },
    r = `${e('aHR0cHM6Ly9haXMueWlndW90ZWNoLmNvbS9zaXRlbWFyay9wcm90ZWN0aW9uL2FwaS92MS93YXRlcm1hcms=')}?shop_domain=${t.shop_domain}`,
    i = () => {
      fetch(r).then((e) => {
        e.json().then((e) => {
          'success' === e.result &&
            ((t = { ...t, ...e, expire_time: Date.now() + 864e5 }),
            'T' === e.is_mark && n(t),
            localStorage.setItem('sitemark_watermark', JSON.stringify(t)));
        });
      });
    },
    s = null,
    n = (e) => {
      if (s) {
        s.disconnect();
        return;
      }
      let { watermark_text: t, watermark_size: r, watermark_color: i } = e,
        o = document.createElement('div');
      ((o.style.position = 'absolute'),
        (o.style.zIndex = '9999'),
        (o.style.left = '50%'),
        (o.style.bottom = '0'),
        (o.style.fontSize = r),
        (o.style.color = i),
        (o.innerHTML = t),
        setTimeout(() => {
          let t = document.querySelector('footer');
          t
            ? ((t.style.position = 'relative'),
              t.appendChild(o),
              (s = new MutationObserver((t) => {
                (s.disconnect(), (s = null), n(e));
              })).observe(t, { attributes: !0, childList: !0, subtree: !0 }))
            : ((o.style.position = 'fixed'), document.body.appendChild(o));
        }, 1e3));
    },
    o = localStorage.getItem('sitemark_watermark');
  if (o) {
    let a = JSON.parse(o);
    ((t = { ...t, ...a }),
      a.expire_time && a.expire_time < Date.now()
        ? i()
        : 'T' === a.is_mark && n(t));
  } else i();
})();

class YGBuyItNow extends HTMLElement {
  constructor() {
    super();
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.scheduledSync = null;
    this.syncRetries = 0;
  }

  connectedCallback() {
    this.triggerButton = this.querySelector('[data-buy-now-trigger]');
    if (!this.triggerButton) return;

    this.triggerButton.addEventListener('click', this.handleTriggerClick);
    this.ownerSection = this.closest('[id^="shopify-section-"]');
    if (this.ownerSection) {
      this.ownerSection.addEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.addEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }

    this.scheduleSync();
  }

  disconnectedCallback() {
    if (this.triggerButton) {
      this.triggerButton.removeEventListener('click', this.handleTriggerClick);
    }
    if (this.ownerSection) {
      this.ownerSection.removeEventListener(
        'variant:change',
        this.handleVariantChange
      );
      this.ownerSection.removeEventListener(
        'bundle-changed',
        this.handleVariantChange
      );
    }
    if (this.scheduledSync) {
      window.cancelAnimationFrame(this.scheduledSync);
      this.scheduledSync = null;
    }
  }

  handleVariantChange() {
    this.syncRetries = 0;
    this.scheduleSync();
  }

  scheduleSync() {
    if (this.scheduledSync) return;
    this.scheduledSync = window.requestAnimationFrame(() => {
      this.scheduledSync = null;
      this.syncState();
    });
  }

  getNativePaymentButton() {
    const selectors = [
      '.shopify-payment-button .shopify-payment-button__more-options',
      '.shopify-payment-button .shopify-payment-button__button'
    ];
    for (const selector of selectors) {
      const candidate = this.querySelector(selector);
      if (!candidate) continue;
      const isDisabled =
        candidate.disabled ||
        candidate.getAttribute('aria-disabled') === 'true';
      if (!isDisabled) return candidate;
    }
    return null;
  }

  syncState() {
    if (!this.triggerButton) return;

    const nativePaymentWrapper = this.querySelector('.shopify-payment-button');
    const nativeButton = this.getNativePaymentButton();
    const wrapperHidden =
      !nativePaymentWrapper || nativePaymentWrapper.offsetParent === null;
    const shouldDisable = !nativeButton || wrapperHidden;

    this.triggerButton.disabled = shouldDisable;
    this.classList.toggle('is-disabled', shouldDisable);

    if (shouldDisable && this.syncRetries < 12) {
      this.syncRetries += 1;
      window.setTimeout(() => this.scheduleSync(), 120);
    } else if (!shouldDisable) {
      this.syncRetries = 0;
    }
  }

  handleTriggerClick(event) {
    event.preventDefault();
    const nativeButton = this.getNativePaymentButton();
    if (!nativeButton) {
      this.syncState();
      return;
    }
    nativeButton.click();
    this.syncRetries = 0;
    window.setTimeout(() => this.scheduleSync(), 120);
  }
}

if (!window.customElements.get('yg-buy-it-now')) {
  window.customElements.define('yg-buy-it-now', YGBuyItNow);
}

document.addEventListener("DOMContentLoaded", function () { 
class YGBuyItNowModal extends HTMLElement {
  constructor() {
    super()
    this.init()
  }
  init() {
    // 这里放置初始化逻辑
    let _this = this
    let $button = _this.querySelector('.yg-buy-it-now-button')
    $button.addEventListener('click', () => _this.buttonClick())
  }
  buttonClick() {
    // 这里放置自定义逻辑
    let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
    buyBtn.click();
  }
}
if (!window.customElements.get('yg-buy-it-now-modal')) {
  window.customElements.define('yg-buy-it-now-modal', YGBuyItNowModal)
}
});

(function () {
  document.addEventListener('DOMContentLoaded', () => {

    /* =========================
     * DOM
     * ========================= */
    const popup = document.querySelector('.yg-product-popup');
    if (!popup) {
      console.warn('[YG Popup] popup not found');
      return;
    }

    const content = popup.querySelector('.yg-product-popup__content');

    /* =========================
     * UI 控制
     * ========================= */

    function openPopup() {
      popup.removeAttribute('hidden');
      popup.classList.add('is-loading');

      content.innerHTML = '<div class="loading">Loading...</div>';
    }

    function closePopup() {
      popup.setAttribute('hidden', '');
      popup.classList.remove('is-loading');
      content.innerHTML = '';
    }

    popup.addEventListener('click', (e) => {
      if (e.target.matches('[data-close]')) {
        closePopup();
      }
    });

    /* =========================
     * 工具函数
     * ========================= */

    function setInnerHTML(element, html) {
      element.innerHTML = html;

      // 重新执行 script
      element.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');

        Array.from(oldScript.attributes).forEach(attr => {
          newScript.setAttribute(attr.name, attr.value);
        });

        newScript.textContent = oldScript.textContent;
        oldScript.replaceWith(newScript);
      });
    }

    function buildQuickViewUrl(handle) {
      return `${Shopify.routes.root}products/${handle}?view=yg-quick-view`;
    }

    function createInstanceId() {
      return `yg-popup-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    }

    /* =========================
     * ✅ 安全版 ID 去重（关键）
     * ========================= */

    function dedupeIds(container, instanceId) {
      if (!container) return;

      const map = new Map();

      container.querySelectorAll('[id]').forEach(el => {

        // ❗关键：这些全部不能动
        if (
          el.tagName === 'FORM' ||
          el.closest('variant-picker') ||
          el.hasAttribute('form') ||
          el.hasAttribute('form-id')
        ) return;

        const newId = `${el.id}`;
        map.set(el.id, newId);
        el.id = newId;
      });

      const attrs = ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'href'];

      attrs.forEach(attr => {
        container.querySelectorAll(`[${attr}]`).forEach(el => {
          let val = el.getAttribute(attr);
          if (!val) return;

          if (attr === 'href' && val.startsWith('#')) {
            const key = val.slice(1);
            if (map.has(key)) {
              el.setAttribute(attr, '#' + map.get(key));
            }
          } else {
            el.setAttribute(
              attr,
              val.split(' ').map(k => map.get(k) || k).join(' ')
            );
          }
        });
      });
    }

    /* =========================
     * 可选：初始化 variant（保险）
     * ========================= */

    function initVariant(container) {
      const firstInput = container.querySelector('input[data-option-position]');
      if (firstInput) {
        setTimeout(() => {
          firstInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, 50);
      }
    }

    function dispatchReady(container, handle) {
      document.dispatchEvent(
        new CustomEvent('YG:productPopupContentReady', {
          detail: { container, handle }
        })
      );
    }

    /* =========================
     * 数据加载
     * ========================= */

    async function loadQuickView(handle) {
      const res = await fetch(buildQuickViewUrl(handle), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) throw new Error('fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const el = doc.querySelector('.main-product-template-wrapper');

      if (!el) throw new Error('quick view template not found');

      return el.outerHTML;
    }

    /* =========================
     * 核心渲染
     * ========================= */

    async function renderHandle(handle) {
      if (!handle) return;

      console.log('[YG] open handle =', handle);

      openPopup();

      try {
        const html = await loadQuickView(handle);

        setInnerHTML(content, html);

        const instanceId = createInstanceId();

        // ✅ 只做安全 dedupe
        dedupeIds(content, instanceId);

        // ✅ 初始化（可选但建议）
        initVariant(content);

        dispatchReady(content, handle);

        popup.classList.remove('is-loading');

      } catch (err) {
        console.error('[YG Popup]', err);

        content.innerHTML = '<div class="error">Failed to load product</div>';

        popup.classList.remove('is-loading');
      }
    }

    /* =========================
     * 点击触发
     * ========================= */

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-yg-product-popup-trigger]');
      if (!trigger) return;

      event.preventDefault();

      const handle = trigger.getAttribute('data-product-handle');
      if (!handle) return;

      renderHandle(handle);
    });

    /* =========================
     * API
     * ========================= */

    window.YGProductPopup = {
      openByHandle: renderHandle,
      close: closePopup
    };

  });
})();